<template>
  <div id="app">
    <router-view></router-view>
  </div>
	  <div class="container-fluid">
		  <div class="row text-center home-header">
              <a href="https://cambro.com/traydesigner/home" class="left-arrow" target="_parent">
                <img src="images/left.svg" />
              </a>
			  <h1>Round Trays</h1>
		  </div>
		  <div class="cleaner"></div>
		  <div class="home-body">
			<div class="round-flex">
				<div class="home-tray">
					<div class="tray-title">
						<h3>Camtrays</h3>
					</div>
                    <div class="tray-pad">
                        <a href="https://cambro.com/traydesigner/round" rel="noopener noreferrer" target="_parent"><img src="images/home_round.png" width="100%" /></a><br />
						<a href="https://cambro.com/traydesigner/round" rel="noopener noreferrer"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
                    </div>
				</div>
				<div class="home-tray">
					<div class="tray-title">
						<h3>EpicTread</h3>
						<h4>Not available in North America</h4>
					</div>
					<div class="tray-pad">
                        <a href="https://cambro.com/traydesigner/epictread" rel="noopener noreferrer" target="_parent"><img src="images/home_epictread.png" width="100%" /></a>
                        <a href="https://cambro.com/traydesigner/epictread" rel="noopener noreferrer" target="_parent"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
					</div>
				
				</div>
					<div class="home-tray">
						<div class="tray-title">
							<h3>Camtread</h3>
						</div>
						<div class="tray-pad">
                            <a href="https://cambro.com/traydesigner/camtread" rel="noopener noreferrer" target="_parent"><img src="images/home_round-camtread.png" width="100%" /></a>
							<a href="https://cambro.com/traydesigner/camtread" rel="noopener noreferrer" target="_parent"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
						</div>
					</div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
  name: 'RoundTrays',
}
</script>
